var render, staticRenderFns
import script from "./device-card.vue?vue&type=script&lang=ts"
export * from "./device-card.vue?vue&type=script&lang=ts"
import style0 from "./device-card.vue?vue&type=style&index=0&id=7db8573d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db8573d",
  null
  
)

export default component.exports